import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { withProcedureWraper } from "..";
import { Routes } from "../../../AppRoutes";
import { Box } from "../../../components/box";
import { Icon } from "../../../components/icon";
import { CreateNotification } from "../../../components/notifier";
import { getDDMMYYYFormat, getHHmmFormat, getUCTDate } from "../../../helper/dateTimeHelper";
import { Button } from "../../../modules/button";
import { Message } from "../../../modules/message";
import { LeaveRequestService } from "../../../services/leave-request/leaveRequest.service";
import { MailService } from "../../../services/mail/mail.service";
import { useSelector } from "../../../store/store";
import { getEnv } from "../../../AppConfigs";
import { mailRegexs } from "../../../constants/mailTemplateConstants";
import FontFa from "../../../components/fontFa/fontFa";
import { requestStatus } from "../../../constants/statusConstants";

const siteUrl = getEnv("REACT_APP_AUTHOR_LEAVE_REQUESTS_URL");

const approverType = {
  approver: 1,
  preapprover: 2,
};

export const LeaveRequestDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();

  const [leaveRequest, setLeaveRequest] = useState(null as any);
  const [approvalType, setApprovalType] = useState(approverType.preapprover);
  const { id } = useRouteMatch().params as any;
  const [comment, setComment] = useState("");
  const [errorMessage, setErrorMessage] = useState(null as any);
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);

  const getLeaveRequest = () => {
    LeaveRequestService.getLeaveRequest(id)
      .then(
        (res) => {
          setLeaveRequest(res);
        },
        (err) => {
          setErrorMessage(err.message);
        },
      )
      .catch((err) => setErrorMessage(err.message));
  };

  const sendMail = async (status: string) => {
    const template = mailtemplates.find((m: any) => m.eMailType === "LRF");
    const statusText = status === requestStatus.approved ? "duyệt" : "từ chối";
    const content = template.eContent
      .replace(mailRegexs.zero, leaveRequest.createdBy.user.displayName)
      .replace(mailRegexs.one, statusText)
      .replace(mailRegexs.siteUrl, siteUrl);
    const subject = template.eSubject.replace("{0}", statusText);
    const message = MailService.buildMailMesssage(subject, content, "html", leaveRequest.createdBy.user.email);
    await MailService.sendMail(message);
  };

  const approveRequest = () => {
    const { fields } = leaveRequest;
    switch (approvalType) {
      case approverType.approver:
        fields.eApprovalComment = comment;
        fields.eRquestStatus = requestStatus.approved;
        fields.eApproved = requestStatus.approved;
        fields.eApprovedDate = getUCTDate();
        break;
      case approverType.preapprover:
        fields.ePreApprovalComment = comment;
        fields.ePreApproved = requestStatus.approved;
        fields.ePreApprovedDate = getUCTDate();
        break;
      default:
        break;
    }
    LeaveRequestService.updateLeaveRequest(leaveRequest.id, fields)
      .then((res) => {
        CreateNotification({ title: "Thành công", body: `Chỉnh sửa thành công.`, icon: "/icons/success.png" });
        sendMail(requestStatus.approved);
        history.push(Routes.procedureLeaveRequest.path);
      })
      .catch((err) => {
        CreateNotification({ title: "Thất bại", body: `Chỉnh sửa thất bại.`, icon: "/icons/error.png" });
        setErrorMessage(err.message);
      });
  };

  const checkEdit = () => {
    return !leaveRequest.fields.ePreApproved && !leaveRequest.fields.eApproved;
  };

  const rejectRequest = () => {
    const { fields } = leaveRequest;
    switch (approvalType) {
      case approverType.approver:
        fields.eApprovalComment = comment;
        fields.eRquestStatus = requestStatus.rejected;
        fields.eApproved = requestStatus.rejected;
        fields.ePreApprovedDate = getUCTDate();
        break;
      case approverType.preapprover:
        fields.ePreApprovalComment = comment;
        fields.eRquestStatus = requestStatus.rejected;
        fields.ePreApproved = requestStatus.rejected;
        fields.ePreApprovedDate = getUCTDate();
        break;
      default:
        break;
    }
    LeaveRequestService.updateLeaveRequest(leaveRequest.id, fields)
      .then((res) => {
        CreateNotification({ title: "Thành công", body: `Chỉnh sửa thành công.`, icon: "/icons/success.png" });
        sendMail(requestStatus.rejected);
        history.push(Routes.procedureLeaveRequest.path);
      })
      .catch((err) => {
        CreateNotification({ title: "Thất bại", body: `Chỉnh sửa thất bại.`, icon: "/icons/error.png" });
        setErrorMessage(err.message);
      });
  };

  const checkApproverType = () => {
    const { eApprovedBy, ePreApprovedBy } = leaveRequest.fields;
    const approverEmail = eApprovedBy ? eApprovedBy.split("|")[0] : "";
    const preApproverEmail = ePreApprovedBy ? ePreApprovedBy.split("|")[0] : "";
    if (currentUserName.toLowerCase() === approverEmail.toLowerCase()) {
      setApprovalType(approverType.approver);
    } else if (currentUserName.toLowerCase() === preApproverEmail.toLowerCase()) {
      setApprovalType(approverType.preapprover);
    }
  };

  const getStepIconByStatus = (status: any) => {
    switch (status) {
      case requestStatus.approved:
        return "faCheck";
      case requestStatus.rejected:
        return "faBan";
      default:
        return "";
    }
  };

  const getStepClassByStatus = (date: any, status: any) => {
    if (date) {
      return status === requestStatus.approved ? "approved" : "rejected";
    } else {
      return "waiting";
    }
  };

  const checkApproval = () => {
    const { eRquestStatus } = leaveRequest.fields;
    if (eRquestStatus === requestStatus.rejected || eRquestStatus === requestStatus.approved) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    getLeaveRequest();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (leaveRequest) {
      checkApproverType();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaveRequest]);

  return (
    <div className="LeaveRequestDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={() => history.push(Routes.procedureApplicationForLeave.path)}>
            <Icon.ArrowLeft />
          </div>
          {"Đơn xin nghỉ phép"}
        </div>
      </div>
      {(() => {
        if (!leaveRequest) return <Message type="loading" />;
        if (errorMessage) return <Message type="error" message={errorMessage} />;

        const { fields, createdDateTime } = leaveRequest;
        const {
          ePreApproved,
          ePreApprovedDate,
          ePreApprovedBy,
          eApprovedDate,
          eApproved,
          eApprovedBy,
          eLeaveStartDate,
          eLeaveEndDate,
          eApprovalComment,
          ePreApprovalComment,
          eDuration,
          eLeaveType,
          eLeaveReason,
        } = fields;
        return (
          <div className="row">
            <div className="col-lg-4 col-md-12 mb-4">
              <Box title="Quy trình duyệt" className="full-height">
                <div className="TimelineBox">
                  <div className="item">
                    <div className="step approved">
                      <FontFa name="faCheck" />
                    </div>
                    <div className="content">
                      <div className="title">{leaveRequest.createdBy.user.displayName}</div>
                      <div className="time">{`Ngày tạo: ${getDDMMYYYFormat(createdDateTime)} - ${getHHmmFormat(
                        createdDateTime,
                      )}`}</div>
                    </div>
                  </div>
                  {ePreApprovedBy && (
                    <div className="item">
                      <div className={`step ${getStepClassByStatus(ePreApprovedDate, ePreApproved)}`}>
                        <FontFa name={getStepIconByStatus(ePreApproved)} />
                      </div>
                      <div className="content">
                        <div className="title">{ePreApprovedBy.split("|")[1]}</div>
                        <div className="time">
                          {ePreApprovedDate ? (
                            `Ngày duyệt: ${getDDMMYYYFormat(ePreApprovedDate)} - ${getHHmmFormat(ePreApprovedDate)}`
                          ) : (
                            <span className="flag default">{"Chưa duyệt"}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {eApprovedBy && (
                    <div className="item">
                      <div className={`step ${getStepClassByStatus(eApprovedDate, eApproved)}`}>
                        <FontFa name={getStepIconByStatus(eApproved)} />
                      </div>
                      <div className="content">
                        <div className="title">{eApprovedBy.split("|")[1]}</div>
                        <div className="time">
                          {eApprovedDate ? (
                            `Ngày duyệt: ${getDDMMYYYFormat(eApprovedDate)} - ${getHHmmFormat(eApprovedDate)}`
                          ) : (
                            <span className="flag default">{"Chưa duyệt"}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Box>
            </div>
            <div className="col-lg-8 col-md-12 mb-4">
              <Box title="Thông tin nghỉ phép" className="full-height">
                <div className="TableInformation">
                  <table>
                    <tbody>
                      <tr>
                        <td colSpan={1}>{"Người yêu cầu"}</td>
                        <td colSpan={3}>{leaveRequest.createdBy.user.displayName}</td>
                      </tr>
                      <tr>
                        <td>Từ ngày</td>
                        <td>
                          <span>{getDDMMYYYFormat(eLeaveStartDate)}</span>
                        </td>
                        <td>Đến ngày</td>
                        <td>
                          <span>{getDDMMYYYFormat(eLeaveEndDate)}</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Số ngày nghỉ phép</td>
                        <td>{eDuration}</td>
                        <td>Loại ngày phép</td>
                        <td>{eLeaveType}</td>
                      </tr>
                      <tr>
                        <td colSpan={1}>Lý do</td>
                        <td colSpan={3}>{eLeaveReason}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="InputWraper">
                  <div className="mb-2">
                    {currentUserName.toLowerCase() === leaveRequest.createdBy.user.email.toLowerCase()
                      ? "Approval's comments"
                      : "Comments"}
                  </div>
                  <div className="wraper">
                    <>
                      {ePreApprovalComment && (
                        <div className="py-2 pl-3">{`Comment người duyệt thứ 1: ${ePreApprovalComment}`}</div>
                      )}
                      {eApprovalComment && (
                        <div className="py-2 pl-3">{`Comment người duyệt thứ 2: ${eApprovalComment}`}</div>
                      )}
                      {currentUserName.toLowerCase() !== leaveRequest.createdBy.user.email.toLowerCase() && (
                        <div className="input">
                          <textarea value={comment} onChange={(e) => setComment(e.target.value)} />
                        </div>
                      )}
                    </>
                  </div>
                </div>
                {currentUserName.toLowerCase() === leaveRequest.createdBy.user.email.toLowerCase()
                  ? checkEdit() && (
                      <div className="d-flex justify-content-center">
                        <Button
                          className="mr5"
                          buttonType="success"
                          label="Chỉnh sửa"
                          onClick={() =>
                            history.push(Routes.procedureLeaveRequestCreateNew.path.replace(":id", leaveRequest.id))
                          }
                        />
                        <Button buttonType="grey" label="Hủy" onClick={() => {}} />
                      </div>
                    )
                  : checkApproval() && (
                      <div className="d-flex justify-content-center">
                        <Button className="mr5" buttonType="success" label="Đồng ý" onClick={approveRequest} />
                        <Button buttonType="grey" label="Không đồng ý" onClick={rejectRequest} />
                      </div>
                    )}
              </Box>
            </div>
          </div>
        );
      })()}
    </div>
  );
});
